import React from "react";
import DashboardHeader from "../../../../components/dashboardHeader";
import CustomContainer from "../../../../components/container/CustomContainer";
import DynamicTable from "../../../../components/table";
import { useNavigate } from "react-router-dom";

const tableHeader = ["ID", "Name", "Class", "Section", "Terms"];

const EducationReportCardPage = () => {
  const navigate = useNavigate();

  return (
    <DashboardHeader>
      <CustomContainer
        primaryHeading={"Report Cards"}
        secondaryHeading={"view all report cards"}
        showBackButton={true}
        handleBack={() => navigate("/dashboard/education")}
      >
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={[]}
          tableData={[]}
        />
      </CustomContainer>
    </DashboardHeader>
  );
};

export default EducationReportCardPage;
